import { Mutation, Action, VuexModule, getModule, Module } from 'vuex-module-decorators';
import { RootState, store } from '../..';
import { Event } from '@/models/jgrow/event';
import { EventForList } from '@/models/jgrow/event-for-list';
import { jgrowEventService } from '@/service/api/jgrow-event.service';

export interface IEventState {
  events: Event[]; // イベントの配列
}
@Module({ dynamic: true, store, name: 'eventModule', namespaced: true })
class EventModule extends VuexModule implements IEventState {
  events: Event[] = [];
  eventForList: EventForList[] = [];

  @Mutation
  setEvents(values: Event[]) {
    this.events = values;
  }

  @Mutation
  setEventForList(values: EventForList[]) {
    this.eventForList = values;
  }

  /**
   * イベント一覧取得
   */
  @Action({ rawError: true })
  async fetchEvents(): Promise<EventForList[]> {
    const events: EventForList[] = await jgrowEventService.getEvents();
    this.setEventForList(events);
    return events;
  }

  /**
   * イベント削除
   */
  @Action({ rawError: true })
  async deleteEvent(id: number) {
    await jgrowEventService.deleteEvent(id);
  }
}

export const eventModule = getModule(EventModule);
